.libraryStatus {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 4px 8px;
	margin-bottom: 8px;
	padding: 5px 12px;
	border: none;
	border-radius: 12px;
	background: color-mix(in srgb, var(--accent) 5%, var(--code-bg));
	color: var(--text);
	font-size: 0.8rem;
	opacity: 0.8;
}

.libraryStatus time {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	color: var(--text);
	font-size: 0.8rem;
}